import { render, staticRenderFns } from "./CovidCasesJul11To172022.vue?vue&type=template&id=e54d9ce4&scoped=true"
import script from "./CovidCasesJul11To172022.vue?vue&type=script&lang=js"
export * from "./CovidCasesJul11To172022.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e54d9ce4",
  null
  
)

export default component.exports